import { render } from "./HomeView.vue?vue&type=template&id=2083c006&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=2083c006&lang=sass"

import exportComponent from "/Users/dominik/Code/Meine Projekte/BigTimer/Timer Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__